import { useEffect, useState } from "react";
import { COMPANY } from "@/lib/constants";
import { isGoogleAdsVisitor } from "@/lib/attribution";

/**
 * The phone number to show this visitor.
 *
 * Visitors who arrived from a Google Ads click see the dedicated ads line, so
 * calls dialled off the website are attributable to the campaign. Calls to the
 * main line carry no campaign signal and are invisible to Google forever.
 * Both numbers ring the same team, so nobody reaches a different business.
 *
 * It starts on the main number and swaps inside an effect deliberately: these
 * pages are prerendered by react-snap, so the static HTML, every crawler and
 * the LocalBusiness JSON-LD all keep the canonical business number.
 */
export function usePhoneNumber() {
    const [isAdsLine, setIsAdsLine] = useState(false);

    useEffect(() => {
        setIsAdsLine(isGoogleAdsVisitor());
    }, []);

    return isAdsLine
        ? { phone: COMPANY.phoneAds, phoneHref: COMPANY.phoneAdsHref, isAdsLine: true }
        : { phone: COMPANY.phone, phoneHref: COMPANY.phoneHref, isAdsLine: false };
}

export default usePhoneNumber;
